module.exports = __webpack_public_path__ + "static/img/dzp3.9a7568d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp3.png
// module id = RaY/
// module chunks = 1